import {User} from 'domain-models'

export const isLuxuryAuctionUser = (user?: User | null): boolean =>
  !!user && !!(user.authority && user.authority.mod_luxury_auctions)

export const luxuryThemeClass = (user?: User | null): string =>
  isLuxuryAuctionUser(user) ? 'emilfrey-luxury' : ''
